import { rewriteImageSrc } from '@/utils/rewriteImageSrc';

interface Props {
  url: string;
  alt: string;
  className?: string;
}

const Image = ({ url, alt, className }: Props) => {
  return <img src={rewriteImageSrc(url)} alt={alt} className={className} />;
};

export default Image;
